/* eslint-disable */

export default {
    init()
    {
        window.fbAsyncInit = () =>
        {
            window.FB.init({
                appId: window._rootData.FB_ID,
                autoLogAppEvents: true,
                xfbml: true,
                version: 'v2.12'
            });
        };

        ( function( d, s, id )
        {
            var js = d.getElementsByTagName( s )[0];
            var fjs = d.getElementsByTagName( s )[0];
            if( d.getElementById( id ) )
            {
                return;
            }
            js = d.createElement( s ); js.id = id;
            js.src = 'https://connect.facebook.net/en_US/sdk.js';
            fjs.parentNode.insertBefore( js, fjs );
        }( document, 'script', 'facebook-jssdk' ) );
    }
}


// WEBPACK FOOTER //
// ./src/app/plugins/fb.js